/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* signupWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.POST_SIGN_UP_ACTION, workerSaga);
  yield takeLatest(ActionConstants.SALESFORCE_AUTH_ACTION, workerSaga);
  yield takeLatest(ActionConstants.EDGE_ONBOARD_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_EMAIL_VERIFICATION_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_RESEND_EMAIL_VERIFICATION_ACTION, workerSaga);
  yield takeLatest(ActionConstants.RESET_PASSWORD_WITH_TOKEN, workerSaga);
}
